// extracted by mini-css-extract-plugin
export default {"togglersection":"toggler_togglersection__QTc8N","headline":"toggler_headline__6KK3z","activelist":"toggler_activelist__afONB"};